module.exports = __webpack_public_path__ + "img/parenting-exercises.409b8fcc.svg";